import { useServices } from '../../../services/useServices';
import { DurableApp } from '../pipelines.model';
import { usePipelineQuery } from './usePipelineQuery';

export const useDurablePipeline = (
  app: DurableApp,
  orchestrator: string,
  history = 50
) => {
  const { pipelines } = useServices();

  return usePipelineQuery(
    ['pipelines', 'durable', app, orchestrator, history],
    () => pipelines.getDurablePipeline(app, orchestrator, history)
  );
};
